import React from "react";
import { Box, BoxProps } from "./Box";

export interface CardProps extends BoxProps {
 padding?: "none" | "sm" | "md" | "lg";
 shadow?: "none" | "sm" | "md" | "lg";
 hover?: boolean;
}

const paddingClasses = {
 none: "p-0",
 sm: "p-4",
 md: "p-6",
 lg: "p-8",
};

const shadowClasses = {
 none: "",
 sm: "",
 md: "",
 lg: "",
};

export const Card: React.FC<CardProps> = ({
 padding = "md",
 shadow = "md",
 hover = false,
 className = "",
 children,
 ...props
}) => {
 return (
  <Box
   className={`
    bg-white border border-store-accent-light
    ${paddingClasses[padding]}
    ${shadowClasses[shadow]}
    ${hover ? "transition-all duration-300 hover: hover:border-store-accent cursor-pointer hover:scale-[1.02]" : ""}
    ${className}
   `
    .trim()
    .replace(/\s+/g, " ")}
   {...props}
  >
   {children}
  </Box>
 );
};

export default Card;
